import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';
import { formatSecondsToHours } from '@/common/utils/formatSecondsToHours';
import { isFiniteNumber } from '@/common/utils/number';

export const DurationCell = ({ value }: { value?: number }) =>
  isFiniteNumber(value) && <OverflowTooltip>{formatSecondsToHours(value)}</OverflowTooltip>;
